import { useState } from 'react'
import imageOne from '../../assets/images/gamewarrior-1.jpg'
import LyricalVideo from '../../assets/images/LyricalVideo.jpg'
import ColorCaller from '../../assets/images/ColorCaller.jpg'
import WebScan from '../../assets/images/WebScan.jpg'
import '../../assets/css/portfolio.css'
const data = [
    {
        type: 'application',
        image: LyricalVideo,
        title: 'Lyrical Video & story Maker',
        color: 'firstchild',
        url : 'https://play.google.com/store/apps/details?id=com.lyricalvideostatus.statusmaker.partical.lyrical.videostatus.maker'
    },
    {
        type: 'application',
        image: ColorCaller,
        title: 'Color caller screen & themes',
        color: 'firstchild',
        url : 'https://play.google.com/store/apps/details?id=com.colorcallerscareen.colortheme.callerscreencastomize'
    },
    {
        type: 'application',
        image: WebScan,
        title: 'WA web scan & status saver',
        color: 'firstchild',
        url : 'https://play.google.com/store/apps/details?id=com.webscan.dualapp.scanner'
    },
    {
        type: 'website',
        image: imageOne,
        title: 'Game Warrior',
        color: 'firstchild',
        url : 'https://game-warrior-03.web.app/'
    },
]
const tabs = [
    {
        title : 'All',
        type : 'all',
    },
    {
        title : 'App Development',
        type : 'application',
    },
    {
        title : 'Web & SaaS Development',
        type : 'website',
    },
]
export default function Gallery() {
    const [active , setActive] = useState(tabs[0].type)

    const tabsHandler = (action ='all') => {
        if(action !== active && action!== '' && action !== null && action !== undefined ){
            console.log(">>>>>>>>",action)
            setActive(action)
        }
    }

    return (
        <>
            <div id="gallery" className="gallery-box">
                <ul className="gallery-tab">
                    {tabs && tabs.length > 0 ? tabs.map(tab => <li onClick={() => tabsHandler(tab?.type)} className={`filter-button ${active === tab?.type ? 'active' : ''}`} data-filter="all">{tab?.title}</li>) : null}
                </ul>
                <div className="row gallery-content-box m-0">
                    {
                        data && data.length > 0 ? data.map(item => active === 'all' || active === item.type ? <div className={`gallery_product col-lg-6 col-md-6 col-sm-6 col-xs-6 filter ${item?.type || ''} moreBox`}>
                            <div className={`gallery-content d-flex flex-column ${item?.color || 'fourthchild'}`}>
                                <img src={item?.image} className="img-responsive rounded" alt={item?.title || 'SRP Infotech'} title={item?.title || 'Made By SRP Infotech'} />
                                <a class="text-decoration-none" href={item?.url} target="blank"><h5 className="pro-title">{item?.title || 'Made By SRP Infotech'}</h5></a>
                            </div>
                        </div> :  null) : null
                    }

                </div>
                <div id="loadMore"><span>Load More</span></div>
            </div>
        </>
    )
}